import axios from 'axios';


const apiUrl = process.env.NODE_ENV === 'production'
? process.env.VUE_APP_API_BASE_URL
: process.env.VUE_APP_API_BASE_URL_LOCAL;

const apiClient = axios.create({
  baseURL: apiUrl,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': '*',
  },
});

// Request Interceptor
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});   

export default apiClient;
